import { useSnackbar } from 'notistack';
import { useContext, useEffect, useState } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { savedAddressList, savedContactList } from '../../../api/privateApis';
import {
  getRouteFormOptions,
  validatePostalCode,
} from '../../../api/shipmentForms';
import detailArrow from '../../../assets/icons/new_icon/center.gif';
import swapIcon from '../../../assets/icons/new_icon/swap.svg';
import { AbilityContext } from '../../../context/AbilityContext';
import { useShipForm } from '../../../context/shipForms';
import useCountriesList from '../../../hooks/useCountriesList';
import {
  RefernceRouteInitialValues,
  addressInitialValues,
  addressInitialVendorValues,
  addressValidationInitialValues,
  addressValidationTrueValues,
  contactInitialValues,
  contactValidationInitialValues,
  contactValidationTrueValues,
} from '../../../initial-values';
import { RootState } from '../../../redux/rootReducer';
import {
  AddressDto,
  ContactDto,
  PostalValidationPayloadDto,
  ReferenceRouteFormDto,
} from '../../../types';
import { isValidEmail, isValidationValidated } from '../../../utils/helper';
import SearchDropdown from '../../global-components/searchDropdown';
import SelectSubAccountDropdown from '../../global-components/selectSubAccountDropdown';
import AddressForm from './addressForm';
import CarrierOptionForm from './carrierOptionsForm';
import ContactForm from './contactForm';
import ReferenceFields from './referenceFields';
import SpecialInstructionsFields from './specialInstructions';
interface Props {
  setShowAttention: any;
  isQuote?: boolean;
  setShowRoutes?: any;
}
function RouteForms({ setShowAttention, isQuote, setShowRoutes }: Props) {
  const {
    setOriginFormData,
    setDestinationFormData,
    setShipperFormData,
    setConsigneeFormData,
    setCarrierOptionsContext,
    setSelectedAccountContext,
    setSelectedJobContext,
    getSelectedJobContext,
    getOriginFormData,
    getSavedQuoteFormDataContext,
    getDestinationFormData,
    getShipperFormData,
    getConsigneeFormData,
    getSelectedCarrierContext,
    setReferenceFormDataContext,
    setSpecialInstructionContext,
    getReferenceFormDataContext,
    getSpecialInstructionContext,
    getSelectedAccountContext,
  } = useShipForm();
  const ability = useContext(AbilityContext);
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const gatewayNumber = new URLSearchParams(location.search).get('job_id');
  const selectedCarrierContextData = getSelectedCarrierContext();
  const referenceFormDataContextData = getReferenceFormDataContext();
  const specialInstructionContextData = getSpecialInstructionContext();
  const originFormContextData: AddressDto = getOriginFormData();
  const destinationFormContextData: AddressDto = getDestinationFormData();
  const shipperFormContextData: ContactDto = getShipperFormData();
  const consigneeFormContextData: ContactDto = getConsigneeFormData();
  const selectedAccountContext: any = getSelectedAccountContext();
  const selectedJobContext: any = getSelectedJobContext();
  const savedQuoteContextData: any = getSavedQuoteFormDataContext();
  const countriesList = useCountriesList();
  const isAddLeg = location.pathname === '/app/add-leg';
  const { provincesList, userData } = useSelector(
    (state: RootState) => state.mainAppData
  );
  const isVendor = userData?.is_vendor;
  const savedQuoteOrigin = savedQuoteContextData?.quoteData?.origin;
  const savedQuoteReference = savedQuoteContextData?.referenceForm;
  const savedQuoteDestination = savedQuoteContextData?.quoteData?.destination;
  //route forms
  const [originForm, setOriginForm] = useState<AddressDto>(
    originFormContextData
      ? originFormContextData
      : savedQuoteOrigin
      ? savedQuoteOrigin
      : addressInitialValues
  );
  const [destinationForm, setDestinationForm] = useState<AddressDto>(
    destinationFormContextData
      ? destinationFormContextData
      : savedQuoteDestination
      ? savedQuoteDestination
      : addressInitialValues
  );
  const [selectedSavedAddressOrigin, setSelectedSavedAddressOrigin] =
    useState(null);
  const [selectedSavedAddressDestination, setSelectedSavedAddressDestination] =
    useState(null);
  const [shipperForm, setShipperForm] = useState<ContactDto>(
    shipperFormContextData ? shipperFormContextData : contactInitialValues
  );
  const [consigneeForm, setConsigneeForm] = useState<ContactDto>(
    consigneeFormContextData ? consigneeFormContextData : contactInitialValues
  );
  //their validations
  const [originFormValidations, setOriginFormValidations] = useState(
    originFormContextData || savedQuoteOrigin
      ? addressValidationTrueValues
      : addressValidationInitialValues
  );
  const [destinationFormValidations, setDestinationFormValidations] = useState(
    destinationFormContextData || savedQuoteDestination
      ? addressValidationTrueValues
      : addressValidationInitialValues
  );
  const [shipperFormValidations, setShipperFormValidations] = useState(
    shipperFormContextData
      ? contactValidationTrueValues
      : contactValidationInitialValues
  );
  const [consigneeFormValidations, setConsigneeFormValidations] = useState(
    consigneeFormContextData
      ? contactValidationTrueValues
      : contactValidationInitialValues
  );
  const [savedOriginAddresses, setSavedOriginAddresses] = useState<any>([]);
  const [savedDestinationAddresses, setSavedDestinationAddresses] =
    useState<any>([]);

  const [savedOriginContacts, setSavedOriginContacts] = useState<any>([]);
  const [savedDestinationContacts, setSavedDestinationContacts] = useState<any>(
    []
  );
  //
  const [referenceRouteForm, setReferenceRouteForm] =
    useState<ReferenceRouteFormDto>(
      referenceFormDataContextData
        ? referenceFormDataContextData
        : savedQuoteReference
        ? savedQuoteReference
        : RefernceRouteInitialValues
    );
  const [routeFormOptions, setRouteFormOptions] = useState<any>();
  const [specialInstructions, setSpecialInstructions] = useState(
    specialInstructionContextData ? specialInstructionContextData : ''
  );
  const [validating, setValidating] = useState(false);
  const [originPostalCodeError, setOriginPostalCodeError] = useState(false);
  const [destinationPostalCodeError, setDestinationPostalCodeError] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [originPostalCodeValidated, setOriginPostalCodeValidated] =
    useState(false);
  const [destinationPostalCodeValidated, setDestinationPostalCodeValidated] =
    useState(false);
  const [selectedCarriers, setSelectedCarriers] = useState<string[]>(
    selectedCarrierContextData ? selectedCarrierContextData : []
  );
  const [selectedAccount, setSelectedAccount] = useState(
    selectedAccountContext
      ? selectedAccountContext
      : '5edcc144-4546-423a-9fcd-2be2418e4720'
  );
  const [selectedJob, setSelectedJob] = useState(
    gatewayNumber ? gatewayNumber : (selectedJobContext || '')
  );
  const [isBBEUser, setIsBBEUser] = useState(
    ability.can('read', 'BBE Process Account')
  );
  function nextRoute() {
    // setShowAttention(true);
    setValidating(true);
    if (originForm?.address === '' && destinationForm?.address === '') {
      enqueueSnackbar('Please provide all the required information', {
        variant: 'error',
      });
      window.scrollTo(0, 0);
    }
    if (
      destinationForm?.address === originForm?.address &&
      originForm?.address !== '' &&
      destinationForm?.address !== ''
    ) {
      enqueueSnackbar('Origin and Destination addresses should be different', {
        variant: 'error',
      });
      window.scrollTo(0, 0);
    }
    if (!isQuote) {
      // Validation for all forms
      if (isVendor && referenceRouteForm?.reference_1 === '') {
        window.scrollTo(0, 0);
        return;
      }
      if (isBBEUser && selectedAccount === '') {
        window.scrollTo(0, 0);
        return;
      }

      if (
        isValidationValidated(originFormValidations) &&
        isValidationValidated(destinationFormValidations) &&
        isValidationValidated(shipperFormValidations) &&
        isValidationValidated(consigneeFormValidations) &&
        destinationForm?.address !== originForm?.address
      ) {
        setValidating(false);
        submitRouteForm();
      } else {
        window.scrollTo(0, 0);
        setLoading(false);
        window.scrollTo(0, 0);
        if (destinationForm?.address !== originForm?.address) {
          enqueueSnackbar('Please provide all the required information', {
            variant: 'error',
          });
        }
      }
    } else {
      // Validation for quick quote
      if (
        isValidationValidated(originFormValidations) &&
        isValidationValidated(destinationFormValidations) &&
        destinationForm?.address !== originForm?.address
      ) {
        setValidating(false);
        submitRouteForm();
      } else {
        window.scrollTo(0, 0);
      }
    }
  }
  function submitRouteForm() {
    setLoading(true);
    let payload: PostalValidationPayloadDto = {
      origin: {
        city: originForm.city,
        country: originForm.country,
        province: originForm.province,
        postal_code: originForm.postal_code,
      },
      destination: {
        city: destinationForm.city,
        country: destinationForm.country,
        province: destinationForm.province,
        postal_code: destinationForm.postal_code,
      },
    };

    validatePostalCode(payload.origin)
      .then((response) => {
        if (!response.data.is_error) {
          setOriginPostalCodeValidated(true);
        }
      })
      .catch((e) => {
        setLoading(false);
        setValidating(true);
        setOriginPostalCodeError(true);
      });
    validatePostalCode(payload.destination)
      .then((response) => {
        if (!response.data.is_error) {
          setDestinationPostalCodeValidated(true);
        }
      })
      .catch((e) => {
        setDestinationPostalCodeError(true);
        setValidating(true);
        setLoading(false);
      });
  }

  function getOptionsRouteForm() {
    getRouteFormOptions()
      .then((data) => {
        setRouteFormOptions(data?.data?.content);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  useEffect(() => {
    getOptionsRouteForm();
    if (gatewayNumber) {
      setSelectedJobContext(gatewayNumber);
    }
  }, []);

  useEffect(() => {
    if (isVendor && !originFormContextData) {
      setOriginForm(addressInitialVendorValues);
      setDestinationForm(addressInitialVendorValues);
    }
  }, [isVendor]);

  useEffect(() => {
    if (originPostalCodeValidated && destinationPostalCodeValidated) {
      setOriginFormData(originForm);
      setDestinationFormData(destinationForm);
      setCarrierOptionsContext(selectedCarriers);
      if (!isQuote) {
        setShipperFormData(shipperForm);
        setConsigneeFormData(consigneeForm);
        setReferenceFormDataContext(referenceRouteForm);
        setSpecialInstructionContext(specialInstructions);
        setSelectedAccountContext(selectedAccount);
        setSelectedJobContext(selectedJob);
      }
      setShowAttention(true);
      setLoading(false);
      window.scrollTo(0, 0);
    }
  }, [originPostalCodeValidated, destinationPostalCodeValidated]);

  function getAddressesAndContacts() {
    savedAddressList({ is_pagination: false })
      .then((response) => {
        if (!response?.data?.is_error) {
          let inputData = response?.data?.content;
          const transformedData = inputData.map((item: any) => {
            const transformedItem = {
              label: `${item.name} - ${item.address.address}, ${item.address.city}, ${item.address.province}, ${item.address.country}`,
              value: item.address,
            };

            if (item.is_origin) {
              // If item.is_origin is true, store it in setSavedOriginAddresses
              setSavedOriginAddresses((prevAddresses: any) => [
                ...prevAddresses,
                transformedItem,
              ]);
            }

            if (item.is_destination) {
              // If item.is_destination is true, store it in setSavedDestinationAddresses
              setSavedDestinationAddresses((prevAddresses: any) => [
                ...prevAddresses,
                transformedItem,
              ]);
            }
          });
        }
      })
      .catch((e) => {});
    if (!isQuote) {
      savedContactList({ is_pagination: false }).then((response) => {
        if (!response?.data?.is_error) {
          let inputData = response?.data?.content;
          const transformedData = inputData.map((item: any) => {
            const transformedItem = {
              label: `${item.contact.company_name}, ${item.contact.name}, ${item.contact.email}, ${item.contact.phone}`,
              value: item.contact,
            };

            if (item.is_origin) {
              setSavedOriginContacts((prev: any) => [...prev, transformedItem]);
            }

            if (item.is_destination) {
              setSavedDestinationContacts((prev: any) => [
                ...prev,
                transformedItem,
              ]);
            }
          });
        }
      });
    }
  }

  useEffect(() => {
    getAddressesAndContacts();
  }, []);

  const swapOriginDestination = () => {
    setDestinationForm((prevDestinationForm) => ({
      ...prevDestinationForm,
      address: originForm.address,
      city: originForm.city,
      country: originForm.country,
      province: originForm.province,
      postal_code: originForm.postal_code,
      has_shipping_bays: originForm.has_shipping_bays,
    }));

    setOriginForm((prevOriginForm) => ({
      ...prevOriginForm,
      address: destinationForm.address,
      city: destinationForm.city,
      country: destinationForm.country,
      province: destinationForm.province,
      postal_code: destinationForm.postal_code,
      has_shipping_bays: destinationForm.has_shipping_bays,
    }));
    if (selectedSavedAddressDestination) {
      setSelectedSavedAddressOrigin(selectedSavedAddressDestination);
    }
    if (selectedSavedAddressOrigin) {
      setSelectedSavedAddressDestination(selectedSavedAddressOrigin);
    }
  };
  
  return (
    <div>
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}
      <div
        className='row mb-3'
        style={
          location?.pathname !== '/app/quick-quote'
            ? { marginTop: '-20px' }
            : {}
        }
      >
        {!isAddLeg && (
          <div className='col-md-5 d-flex   align-items-center gap-4 '>
            {isBBEUser && location.pathname !== '/app/quick-quote' && (
              <div className='w-100 my-auto'>
                <SelectSubAccountDropdown
                  setSelectedSubAccount={setSelectedAccount}
                  selectedSubAccount={selectedAccount}
                />
                {validating && selectedAccount === '' && (
                  <div className='error_text'>
                    {'Please select a valid account.'}
                  </div>
                )}
              </div>
            )}
            {location.pathname !== '/app/quick-quote' && !isVendor && (
              <div className='w-100 my-auto'>
                {
                  gatewayNumber && (
                      <div>
                        <div>My BBE#</div>
                        <div>{gatewayNumber}</div>
                      </div>
                    )
                }
              </div>
            )}
          </div>
        )}
      </div>

      <div id='route_section'>
        <div className='row mt-2'>
          <div className='col-md-12 col-lg-5'>
            <div className='ubbe-card'>
              <div className='ubbe-card-header'>
                <h5 className='ps-3 mb-0 GlobalBoxHead'>Origin</h5>
              </div>
              <div className='card-body p-4'>
                <div className='row'>
                  <div className='col-sm-12 col-md-12'>
                    <SearchDropdown
                      id={'origin_saved_address'}
                      dontShowAlreadySelected={true}
                      selectedValue={selectedSavedAddressOrigin}
                      options={savedOriginAddresses && savedOriginAddresses}
                      isDisabled={isAddLeg}
                      label='Select saved origin'
                      onSelect={(item) => {
                        if (item?.value !== '') {
                          const { id, address_two, ...rest } = item?.value;
                          setOriginForm(rest);
                          setSelectedSavedAddressOrigin(item);
                          setOriginFormValidations(addressValidationTrueValues);
                        }
                      }}
                    />
                  </div>
                </div>
                {!isVendor && (
                  <div className='text-center pt-4 pb-2 divider'>or</div>
                )}

                <AddressForm
                  countriesList={countriesList}
                  provincesList={provincesList}
                  setFormData={setOriginForm}
                  formData={originForm}
                  validating={validating}
                  setFormValidation={setOriginFormValidations}
                  formValidation={originFormValidations}
                  postalCodeError={originPostalCodeError}
                  origin={true}
                  isDisabled={isAddLeg}
                />
              </div>
            </div>
            {!isQuote && (
              <div className='ubbe-card mt-4'>
                <div className='ubbe-card-header'>
                  <h5 className='ps-3 mb-0 GlobalBoxHead'>Shipper</h5>
                </div>
                <div className='card-body p-4'>
                  <div className='row'>
                    <div className='col-sm-12 col-md-12'>
                      <SearchDropdown
                        id={'origin_saved_contact'}
                        label='Select Saved Shipper'
                        dontShowAlreadySelected={true}
                        options={savedOriginContacts && savedOriginContacts}
                        onSelect={(item) => {
                          if (item?.value !== '') {
                            const { id, ...rest } = item?.value;
                            const phoneDigitsOnly = rest?.phone?.replace(
                              /\D/g,
                              ''
                            );
                            setShipperForm({
                              ...rest,
                              phone: phoneDigitsOnly,
                            });
                            setShipperFormValidations({
                              ...shipperFormValidations,
                              company_name: rest.company_name !== '',
                              email: isValidEmail(rest.email),
                              name: rest.name !== '',
                              phone:
                                phoneDigitsOnly && phoneDigitsOnly.length > 9,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  {!isVendor && (
                    <div className='text-center pt-4 pb-2 divider'>or</div>
                  )}
                  <ContactForm
                    title={'Save Shipper'}
                    setFormData={setShipperForm}
                    formData={shipperForm}
                    validating={validating}
                    setFormValidations={setShipperFormValidations}
                    formValidation={shipperFormValidations}
                  />
                </div>
              </div>
            )}
          </div>
          <div className='col-2 mx-auto  d-flex flex-column '>
            {!isVendor &&
              !isAddLeg &&
              (isValidationValidated(originForm) ||
                isValidationValidated(destinationForm)) && (
                <OverlayTrigger
                  placement='top'
                  delay={{ show: 150, hide: 200 }}
                  overlay={(props) => (
                    <Tooltip id='button-tooltip' {...props}>
                      Swap Origin & Destination
                    </Tooltip>
                  )}
                >
                  <img
                    style={{ height: '59px', width: '59px' }}
                    className='details-arrow w-100 cursor_pointer'
                    src={swapIcon}
                    onClick={swapOriginDestination}
                    alt='Details Arrow'
                  />
                </OverlayTrigger>
              )}

            <div className='d-flex flex-column' style={{ marginTop: '258px' }}>
              <img
                className='details-arrow w-100'
                src={detailArrow}
                alt='Details Arrow'
              />
              {/* <img src={dotted} /> */}
            </div>
          </div>

          <div className='col-md-12 col-lg-5'>
            <div className='ubbe-card'>
              <div className='ubbe-card-header'>
                <h5 className='ps-3 mb-0 GlobalBoxHead'>Destination</h5>
              </div>
              <div className='card-body p-4'>
                <div className='row'>
                  <div className='col-sm-12 col-md-12'>
                    <SearchDropdown
                      id={'destination_saved_address'}
                      label='Select saved destination'
                      dontShowAlreadySelected={true}
                      selectedValue={selectedSavedAddressDestination}
                      options={
                        savedDestinationAddresses && savedDestinationAddresses
                      }
                      onSelect={(item) => {
                        if (item?.value !== '') {
                          const { id, address_two, ...rest } = item?.value;
                          setSelectedSavedAddressDestination(item);
                          setDestinationForm(rest);
                          setDestinationFormValidations(
                            addressValidationTrueValues
                          );
                        }
                      }}
                    />
                  </div>
                </div>
                {!isVendor && (
                  <div className='text-center pt-4 pb-2 divider'>or</div>
                )}
                <AddressForm
                  countriesList={countriesList}
                  provincesList={provincesList}
                  setFormData={setDestinationForm}
                  formData={destinationForm}
                  validating={validating}
                  setFormValidation={setDestinationFormValidations}
                  formValidation={destinationFormValidations}
                  postalCodeError={destinationPostalCodeError}
                  sameAddressError={
                    originForm.address === destinationForm.address
                  }
                />
              </div>
            </div>
            {!isQuote && (
              <div className='ubbe-card mt-4'>
                <div className='ubbe-card-header'>
                  <h5 className='ps-3 mb-0 GlobalBoxHead'>Consignee</h5>
                </div>
                <div className='card-body p-4'>
                  <div className='row'>
                    <div className='col-sm-12 col-md-12'>
                      <SearchDropdown
                        label='Select Saved Consignee'
                        id={'destination_saved_contact'}
                        dontShowAlreadySelected={true}
                        options={
                          savedDestinationContacts && savedDestinationContacts
                        }
                        onSelect={(item) => {
                          if (item?.value !== '') {
                            const { id, ...rest } = item?.value;
                            const phoneDigitsOnly = rest?.phone?.replace(
                              /\D/g,
                              ''
                            );
                            setConsigneeForm({
                              ...rest,
                              phone: phoneDigitsOnly,
                            });
                            // setConsigneeForm(rest);
                            setConsigneeFormValidations({
                              ...consigneeFormValidations,
                              company_name: rest.company_name !== '',
                              email: isValidEmail(rest.email),
                              name: rest.name !== '',
                              phone:
                                phoneDigitsOnly && phoneDigitsOnly.length > 9,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  {!isVendor && (
                    <div className='text-center pt-4 pb-2 divider'>or</div>
                  )}
                  <ContactForm
                    setFormData={setConsigneeForm}
                    title={'Save Consignee'}
                    formData={consigneeForm}
                    validating={validating}
                    setFormValidations={setConsigneeFormValidations}
                    formValidation={consigneeFormValidations}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        {!isQuote && (
          <div className='row mt-4'>
            <div className='col-md-12 col-lg-5'>
              <div className='ubbe-card h-100'>
                <div className='ubbe-card-header'>
                  <h5 className='ps-3 mb-0 GlobalBoxHead'>Reference Numbers</h5>
                </div>
                <div className='card-body p-4'>
                  <p className='mb-3'>
                    Tell us if your shipment has any special references.
                  </p>
                  <ReferenceFields
                    referenceRouteForm={referenceRouteForm}
                    setReferenceRouteForm={setReferenceRouteForm}
                    validating={validating}
                    isVendor={isVendor}
                  />
                </div>
              </div>
            </div>

            <div className='col-2 mx-auto my-auto text-center'>&nbsp;</div>

            <div className='col-md-12 col-lg-5'>
              <div className='ubbe-card h-100'>
                {' '}
                <div className='ubbe-card-header'>
                  <h5 className='ps-3 mb-0 GlobalBoxHead'>
                    Overall Shipment Instructions
                  </h5>
                </div>
                <div className='card-body p-4'>
                  <p className='mb-3'>
                    Tell us if your shipment has any special instructions.
                  </p>
                  <SpecialInstructionsFields
                    specialInstructions={specialInstructions}
                    setSpecialInstructions={setSpecialInstructions}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        <CarrierOptionForm
          carrierOptions={routeFormOptions}
          selectedCarriers={selectedCarriers}
          setSelectedCarriers={setSelectedCarriers}
        />

        <div
          className={`d-flex my-5 ${
            isAddLeg ? 'justify-content-between' : ' justify-content-end'
          } align-items-center`}
        >
          {isAddLeg && (
            <div className=''>
              <p
                className='btn btn-ubbe-new-back d-flex gap-2'
                onClick={() => {
                  setShowRoutes && setShowRoutes(false);
                }}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='15'
                  height='8'
                  viewBox='0 0 15 8'
                  fill='none'
                >
                  <path
                    d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                    fill='black'
                  />
                </svg>
                Back
              </p>
            </div>
          )}
          <div
            className='text-end'
            onClick={() => {
              !loading && nextRoute();
            }}
          >
            <p className='btn btn-ubbe-new-blue'>Continue</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RouteForms;
